import { PlaycastMessage, PlaycastMessageSource, PlaycastMessageTarget, PlaycastTimingEntry } from '../../types';
import { generateMessageHeader } from './generateHeader';
import { generateSignature } from './generateSignature';

export const formatMessage = (
  hostId: string,
  source: PlaycastMessageSource,
  body: PlaycastMessageTarget,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageTarget> => {
  const header: PlaycastMessage<PlaycastMessageTarget>['header'] = {
    ...generateMessageHeader(hostId, source, userAuth),
    target: body.target,
    action: body.action,
    isReply: body.isReply,
  };

  const signature = generateSignature(JSON.stringify(header));

  const initialTiming: PlaycastTimingEntry = {
    app: source,
    timestamp: Date.now(),
    description: 'generateMessage',
    metadata: {},
  };

  return {
    signature,
    header,
    body: {
      message: body.message,
      timings: [initialTiming],
      stats: [],
      echo: false,
    },
  };
};

export const addTiming = <T extends PlaycastMessageTarget>(
  msg: PlaycastMessage<T>,
  timing: {
    timestamp: number;
    description: string;
  },
  app?: PlaycastTimingEntry['app'],
  metadata?: Record<string, string>,
): PlaycastMessage<T> => {
  const entry: PlaycastTimingEntry = {
    app: app ?? msg.header.source,
    timestamp: timing.timestamp ?? Date.now(),
    metadata: metadata ?? {},
    description: timing.description,
  };

  return {
    ...msg,
    body: {
      ...msg.body,
      timings: [...(msg.body.timings || []), entry],
    },
  };
};
